var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Details',{attrs:{"compName":_vm.$t('superDeals')}})}
var staticRenderFns = []

export { render, staticRenderFns }